module.exports = require("./lrc-IQ.js");